import React, { useEffect } from "react";

import FooterC from "../components/FooterC";
import NavbarCandidate from "../components/NavbarCandidate";
import { useHistory } from "react-router-dom";
import NavbarUser from "../components/NavbarUser";

function CandidateDashboard({ children }) {
  const history = useHistory();
  useEffect(() => {
    if (
      localStorage.getItem("candidate.token") === null ||
      localStorage.getItem("candidate.name") === null ||
      localStorage.getItem("candidate.email") === null ||
      localStorage.getItem("candidate.id") === null
    ) {
      history.push("/careers"); // Goto the login page
    }
  }, []);
  return (
    <div id="wrapper">
      <div
        id="content-wrapper-candidate-dashboard"
        className="d-flex flex-column"
      >
        <div id="content" className="mb-3">
          {/* <NavbarCandidate /> */}
          <NavbarUser />
          <div
            className="container-fluid px-2"
            style={{
              minHeight: "5calc(100vh - 120px)",
            }}
          >
            {children}
          </div>
        </div>
        <FooterC />
      </div>
    </div>
  );
}

export default CandidateDashboard;
